import { writable } from 'svelte/store';

export const activeTab = writable('pull-requests');
